
import React, { Component } from "react";
import DashboardLayout from "../../Components/Theme/DashboardLayout";
import PageTitle from "../../Components/Theme/PageTitle";
import { Col, Row } from "antd";
import {InfoCard} from "../../Components/Theme/Cards";
import {StrokeIcon} from "../../Components/Theme/Icon";
import { Link } from 'react-router-dom';
import Spinner from '../../Components/Theme/Spinner';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AuthLogic from '../../AuthLogic'
import {Modal } from "antd";

export class DefaultDashboardPage extends Component {
    constructor(props) {
        super(props)
        this.messages = (props.user.instantMessages || {}).messages || []
        this.state = { visible: true, currentIndexMessage: 0, messagesShowed: false };
        this.props = props;
    }
    // In to disable redirects for sections that aren't in phase 1
    handleClick = e => {
        e.preventDefault();
    }

    handleCloseModal =() => {
        let newCurrent = this.state.currentIndexMessage+1
        this.setState({currentIndexMessage: newCurrent});

        if(newCurrent < this.messages.length) {
            this.showMessages(newCurrent)
            } else {
                localStorage.setItem('isInstantMessagesShowed',true)
            }
        return null
    }
    
    showMessages =(i) => {
        if(this.messages.length == 0) {
            return;
        }
        if (localStorage.getItem('isInstantMessagesShowed')) {
            return;
        }

        Modal.info({
          title: 'Messages',
          destroyOnClose: true,
          content: (
            <div>
              <p style={{whiteSpace: 'pre-line'}}>{this.messages[i].message}</p>
            </div>
          ),
          onOk: this.handleCloseModal,
        });
        
        
      }

    componentDidMount =()=>{
        this.showMessages(this.state.currentIndexMessage)
    }


    render() {
        if (this.props.user.securityLevels) {
            
            return (
                <DashboardLayout>
                    {/*** Page Title ***/}
                    <PageTitle title={'Dashboard'}
                        subTitle={'Welcome to STORM Mobile.'} />
                    
                   
                    <Row gutter={32}>
                    
                        <Col lg={6} md={24}>
                            <Link to="/my-quick-schedule"><InfoCard isDisabled={false} icon={<StrokeIcon icon={'smile'} />}
                                value={'My Quick Schedule'} /></Link>
                        </Col>

                        <Col lg={6} md={24}>
                            <Link to="/schedules"><InfoCard isDisabled={false} icon={<StrokeIcon icon={'clock'} />}
                                value={'View Schedules'} /></Link>
                        </Col>
                        

                        {//AuthLogic.adjustWorkTimes(this.props.user) &&
                         //   (
                        //      <Col lg={8} md={24}>
                        //            {/* <Link to="adjust-work-times" onClick={/*In to disable links for phase 1*/ /*this.handleClick} ><InfoCard isDisabled={true} icon={<StrokeIcon icon={'tools'}/>} */}
                        //            {/* value={'Adjust Work Times/Enter Comments'}/></Link> */}
                        //        </Col>
                        //    )
                        }
                        

                        {/*<Col lg={6} md={24}>
                            <Link to="tours-offered" onClick={this.handleClick}><InfoCard isDisabled={true} icon={<FlatIcon icon={'tool'}/> }
                            value={'View / Accept Tours Offered'}/></Link> 
                        </Col>*/}
                        
                        {(AuthLogic.viewCalendar(this.props.user) || AuthLogic.addDayTypeRequest(this.props.user))&&<Col lg={6} md={24}>
                            <Link to="day-types"><InfoCard icon={<StrokeIcon icon={'date'} />}
                                value={'Days Off and Availability'} /></Link>
                        </Col>}

                        <Col lg={6} md={24}>
                            <Link to="/service-now" target="_blank"><InfoCard isDisabled={false} icon={<StrokeIcon icon={'help1'} />}
                                value={'STORM Help Ticket'} /></Link>
                        </Col>

                    </Row>
                </DashboardLayout>
            )
        } else return <Spinner />

    }

}

DefaultDashboardPage.propTypes = {
    user: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        user: state.user
    }
}


export default connect(
    mapStateToProps
)(DefaultDashboardPage);



// WEBPACK FOOTER //
// ./src/Pages/Dashboards/Default.js